import { Component, ViewContainerRef } from '@angular/core';
import { Coupon, ProductSelectList } from '../../../models/coupons/coupon-model';
import { Product } from '../../../models/products/product.model';
import { Category } from '../../../models/category/category.model';
import { CouponsService } from '../../../services/coupons/coupons.service';
import { CategoryService } from '../../../services/category/category.service';
import { ProductService } from '../../../services/product/product.service';
import { DiscountType } from '../../../models/coupons/discount-type-model';
import { DiscountTypeService } from '../../../services/coupons/discount-type.service';
import { FormsModule, FormControl, Validators } from '@angular/forms';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { Router } from "@angular/router";
import { EnumDropDown } from '../../../models/shared/enum-dropdown'
import { CustomerService } from '../../../services/customer/customer.service';
import { Customer } from '../../../models/customer/customer-model';
import { RolePermissionService } from '../../../services/role/role-permission.service';

@Component({
  selector: 'app-create-coupon',
  templateUrl: './create-coupon.component.html',
  styleUrls: ['./create-coupon.component.scss']
})
/** create-coupon component*/
export class CreateCouponComponent {
  couponModel = new Coupon();
  productIds = new ProductSelectList();
  discountTypeList: DiscountType[];
  public plateFormsList: EnumDropDown[];
  vendorList: Customer[];
  categories: Category[];
  minDate: Date;
  maxDate: Date;
  endMaxDate: Date;
  productlist: Product[];
  products: Product[];
  product = new Product();
  validate: boolean;
  isUnique: boolean = true;
  showProductList: boolean = false;
  showCategoryList: boolean = false;
  showCouponMsg: boolean = false;
  couponType: string;
  public showSuggestions: boolean = false;
  public showProduct: boolean = false;
  public createDateElement: any;
  public startDateElement: any;
  public endDateElement: any;
  public showPercent: boolean = false;
  public showFixed: boolean = false;
  public productsDropdownSettings = {
    singleSelection: false,
    idField: 'productID',
    textField: 'name',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: true
  };

  public categoriesDropdownSettings = {
    singleSelection: false,
    idField: 'categoryID',
    textField: 'categoryName',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 3,
    allowSearchFilter: true
  };

  errorMessage: any;
  /** create-coupon ctor */
  constructor(private readonly couponsService: CouponsService,
    private readonly discountTypeService: DiscountTypeService,
    private readonly categoryService: CategoryService,
    private readonly customerService: CustomerService,
    private readonly productService: ProductService,
    public toastr: ToastsManager, vcr: ViewContainerRef,
    private readonly router: Router, private readonly rolePermissionService: RolePermissionService) {
    this.rolePermissionService.GetRolePermissions("coupon").subscribe(
      data => {
        if (data != null) {

          var create = data.filter(function (element) {
            return (element.action == "create");
          });

          if (create.length > 0) {
            this.getDiscountTypes();
            //this.getProducts();
            this.getVendorsList();
           // this.getCategories();
            this.couponModel.discountTypeId = null;
            this.couponModel.vendorId = null;
            this.couponModel.plateFormID = null;
            this.couponModel.isActive = true;
            this.couponModel.couponID = 0;
            this.products = [];
            this.productlist = [];
            this.validate = true;
            this.GetDomainTypes();
            this.toastr.setRootViewContainerRef(vcr);
          }
          else {
            this.router.navigate(["/coupons"]);
          }
        }
        else {
          this.router.navigate(["/coupons"]);
        }
      }
    )
    this.minDate = new Date();
    this.maxDate = new Date();
    this.endMaxDate = new Date();
    this.minDate.setDate(this.minDate.getDate());
    this.couponType = "";
    this.showCategoryList = false;
    this.showProductList = false;
  }

  GetDomainTypes() {
    this.couponsService.GetDomainTypes().subscribe(
      data => {
        this.plateFormsList = data;
      }
    )
  }
  couponCodeFocus() {

  }
  showCouponType() {
    if (this.couponType == "") {
      this.showProductList = false;
      this.showCategoryList = false;
      this.showCouponMsg = false;
    }
    if (this.couponType =="1") {
      this.showProductList = false;
      this.showCategoryList = true;
      this.showCouponMsg = false;
      this.getCategoriesByVendorId(this.couponModel.vendorId);

    }
    if (this.couponType == "2") {
      this.showCategoryList = false;
      this.showProductList = true;
      this.showCouponMsg = false;
    }
    if (this.couponType == "0") {
      this.showCategoryList = false;
      this.showProductList = false;
      this.showCouponMsg = false;
    }
  }
  getVendorsList() {
    this.customerService.getActiveVendors().subscribe(
      data => {
        this.vendorList = data;
      }
    )
  }
  onSubmit() {
    this.validate = false;
    if (this.couponType == "") {
      this.showCouponMsg = true;
      return;
    }
    else {
      this.showCouponMsg = false;
    }
    if (this.couponType == "0") {
      this.couponModel.productIds = [];
      this.products = [];
      this.categories = [];
    }
    if (this.couponModel.productIds.length == 0 && this.couponModel.categoryIds.length == 0 && this.couponModel.products.length == 0 && this.couponType != "0") {
      this.showCouponMsg = true;
      return;
    }
    else {
      this.showCouponMsg = false;
    }

    this.couponsService.isUniqueCode(this.couponModel.couponCode, this.couponModel.couponID).subscribe(
      data => {
        if (data == true) {
          this.isUnique = true;
          this.couponsService.AddCoupon(this.couponModel).subscribe(result => {
            if (result) {
              this.toastr.success('Coupons has been Saved. ', 'Success');
              setTimeout(() => {
                this.router.navigate(["/coupons"]);
              }, 1000);
            }
            else {
              this.toastr.error('Error occurred. Please try again', 'Error');
              
            }
          });
        }
        else {
          this.isUnique = false;
          this.validate = true;
          window.scroll(0, 0);
        }
      });
  }
  isActiveCheckbox(e) {
    this.couponModel.isActive = e.target.checked;
  }
  getDiscountTypes() {
    this.discountTypeService.getActiveDiscountTypes().subscribe(
      data => {
        this.discountTypeList = data;
      }
    )
  }
  selectStartDate(e) { 
    if (e != null) {
      this.couponModel.startDate = e;
      this.maxDate = e;
      this.endMaxDate = new Date(this.maxDate);
      this.endMaxDate.setDate(this.maxDate.getDate() + 1);
    }
  }
  selectEndDate(e) {
    if (e != null) {
      this.couponModel.endDate = e;
    }
  }



  getProducts() {
    this.productService.GetProducts().subscribe(
      data => {
        this.products = data;
      }
    )
  }
  getCategories() {
    this.categoryService.GetCategoryList().subscribe(
      data => {
        this.categories = data;
      }
    )
  }
  getCategoriesByVendorId(id: number) {
    if (id == null) {
      id = 0;
      this.couponModel.vendorId = 0;
    }
    this.categoryService.GetCategoryListByVendor(id).subscribe(
      data => {
        this.categories = data;
      }
    )
  }
  onSearch(searchText: string) {
    var length = 0;
    try {
      length = searchText.length;
    } catch (e) {
      this.showSuggestions = false;
      return;
    }
    if (length > 0) {
      if (this.couponModel.vendorId == null) {
        this.couponModel.vendorId = 0;
      }
      this.productService.ProductSuggestionsByVendor(searchText,this.couponModel.vendorId).subscribe(
        data => {
          this.productlist = data;
          
          if (this.productlist.length > 0)
          {
            this.showSuggestions = true;
          }
        });
    }
    else {
      this.productlist = [];
      this.showSuggestions = false;
    }
  }
  SelectProduct(product: Product) {
    this.product = product;
    if (!this.products.some((item) => item.productID == this.product.productID)) {
      this.products.push(this.product);
      this.showProduct = true;
      this.productIds = new ProductSelectList();
      this.productIds.productID = this.product.productID;
      this.productIds.name = this.product.name;
      this.couponModel.productIds.push(this.productIds);
    }
    else {
      this.toastr.error('This item is already Exist', 'Fail!');
    }
    this.showSuggestions = false;
  }
  cancelProduct(index) {
    this.products.splice(index, 1);
    if (this.products.length == 0) {
      this.showProduct = false;
    }
  }
  keyPress(event: any) {
    let charCode = (event.which) ? event.which : event.keyCode;
    if (charCode != 46 && charCode > 31
      && (charCode < 48 || charCode > 57))
      return false;
    return true;
  }
  ExistErrorHide() {
    this.isUnique = true;
  }
  ShowDiscountTypeAmount() {
    let discountNatue=this.discountTypeList.filter(x => x.discountTypeID == this.couponModel.discountTypeId)[0];
    
    if (discountNatue.discountNatureType == 1) {
      this.couponModel.couponAmount =null;
      this.showPercent = true;
      this.showFixed = false;
    }
    if (discountNatue.discountNatureType == 2) {
      this.couponModel.couponAmount = null;
      this.showFixed = true;
      this.showPercent = false;
    }
  }
  checkPercent(event: any) {
    if (this.couponModel.couponAmount > 100) {
      this.couponModel.couponAmount = 100;
    }
    let charCode = (event.which) ? event.which : event.keyCode;
    if ((charCode < 48 || charCode > 57) && (charCode < 96 || charCode > 105)) {
      this.couponModel.couponAmount = null;
      return false;
    }
    return true;

  }
}



// WEBPACK FOOTER //
// ./src/app/coupons/coupons/create-coupon/create-coupon.component.ts